import { BareButton } from '@calendly/ui/components/bare-button';
import { ArrowChevronLeftMiniIcon, ArrowChevronRightMiniIcon } from '@calendly/ui/components/icons';
import classNames from 'classnames';
import { forwardRef } from 'react';
const controlButtonDisabledCss = "c6fy81g";
const controlButtonCss = "c19eidba";
const ControlButton = forwardRef((props, ref) => {
  const {
    disabled,
    ...restProps
  } = props;
  return <BareButton ref={ref} {...restProps} className={classNames(controlButtonCss, {
    [controlButtonDisabledCss]: disabled
  }, props.className)} />;
});
const controlsCss = "c1j35vzy";
export const Controls = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    prevMonth,
    nextMonth,
    prevMonthDisabled,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(controlsCss, props.className)}>
      <ControlButton aria-label="previous month" onClick={prevMonth} disabled={prevMonthDisabled}>
        <ArrowChevronLeftMiniIcon size="large" />
      </ControlButton>
      <ControlButton aria-label="next month" onClick={nextMonth}>
        <ArrowChevronRightMiniIcon size="large" />
      </ControlButton>
    </Component>;
});

require("./controls.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./controls.js");